import axios from 'axios';
import qs from "qs";

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL
})

service.interceptors.request.use(
  config => {
    config.data = qs.stringify(config.data);
    return config;
  },
  error => {
    console.error(error);
    return Promise.reject(error);
  }
)

service.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.error(error);
    return Promise.reject(error);
  }
)

export default service
